import { useLocalStore } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';

import Tasks from 'APP/Tasks';
import { GroupType } from 'APP/model/group/groupModel.types';
import { TextPayload } from 'STORE/Messages/Message/Payload/TextPayload/TextPayload';

export default () => {
  const location = useLocation();
  const navigate = useNavigate();
  const message = location.state.message;

  const presenter = useLocalStore(() => ({
    shareToChat(groupId) {
      const payload = new TextPayload({ text: message });

      const canSend = Tasks.messaging.canSendMessage({ groupId, payload });
      if (!canSend.result) {
        canSend.error && Tasks.app.showToast(canSend.error);
        return;
      }

      Tasks.messaging.createNewMessages(groupId, [{ payload }]);
    },
    send: async (data) => {
      let { type, data: target } = data;
      switch (type) {
        case 'chat': {
          if (target.type === GroupType.SavedMessagesFake) {
            target = await Tasks.group.createGroupAndInvite({
              type: GroupType.MySavedMessages,
            });
          }
          presenter.shareToChat(target.id);
          break;
        }
        case 'channel': {
          presenter.shareToChat(target.id);
          break;
        }
        case 'contact': {
          if (!target.group) {
            target = await Tasks.group.createP2PGroup(target.id);
            presenter.shareToChat(target.id);
          } else {
            presenter.shareToChat(target.group.id);
          }
          break;
        }
        default:
          break;
      }

      return target.group ? target.group : target;
    },
    get isAvailableToShow() {
      return Boolean(message);
    },
    onClose() {
      navigate(-1);
    },
    onSelect: async (selection) => {
      const target = await presenter.send(selection[0]);
      presenter.onClose(target);
    },
    onSuccess(target) {
      let { route, id } = target;
      navigate(`/${route}/${id}`);
    },
  }));

  return presenter;
};
